import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "image", "initial", "error"]
  static values = {
    maxBytes: { type: Number, default: 0 },
    tooLargeMessage: String
  }

  pick(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  loadPreview(event) {
    const file = event.target.files[0]
    if (!file) return

    if (this.maxBytesValue > 0 && file.size > this.maxBytesValue) {
      this.#showError(this.tooLargeMessageValue)
      this.inputTarget.value = ""
      return
    }
    this.#clearError()

    const reader = new FileReader()
    reader.onload = () => {
      if (this.hasImageTarget) {
        this.imageTarget.src = reader.result
        this.imageTarget.classList.remove("hidden")
      }
      if (this.hasInitialTarget) {
        this.initialTarget.classList.add("hidden")
      }
    }
    reader.readAsDataURL(file)
  }

  #showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove("hidden")
    } else {
      window.alert(message)
    }
  }

  #clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("hidden")
    }
  }
}
